<template>
    <div class="y-btn-group">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'y-button-group'
}
</script>
<style lang="less">
@import "./button-group";
</style>


// WEBPACK FOOTER //
// button-group.vue?057be5a1